import { render } from "./MovieSeat.vue?vue&type=template&id=47b8ed02&scoped=true"
import script from "./MovieSeat.vue?vue&type=script&lang=js"
export * from "./MovieSeat.vue?vue&type=script&lang=js"

import "./MovieSeat.vue?vue&type=style&index=0&id=47b8ed02&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b8ed02"]])

export default __exports__